<script>
import TaskAdd from "@/components/Content/Task/TaskAdd";
import TaskView from "@/components/Content/Task/TaskView";
import { api } from "@/api/index";
import { store } from "@/store/index";
import { mapState, mapGetters } from "vuex";

export default {
  mixins: [TaskAdd],
  data() {
    return {
      projectUsers: [],
      somethingChanged: false,
      timecritical: undefined,
      title: undefined,
      description: undefined,
      selectedPriority: 0,
      selectedTags: [],
      selectedUSers: [],
      task: true,
      haveChange: false,
      edit: true,
      componentTitle: "Edit Task",
      currentInfo: [],
      title: undefined,
      description: undefined,
      deadline: undefined
    };
  },
  computed: {
    ...mapGetters({
      taskID: "selectedItemID",
      currentTabData: "currentTabData"
    }),

    ...mapState({
      tabIndex: "currentTabIndex",
      suggestedWorker: state => store.getters.getSuggestedUsers,
      suggestedTags: state => state.modulework.suggestedTags,
      suggestedProjects: state => state.modulework.suggestedProjects,
      proId: state => state.sidebarItemSelection[0]
    }),

    blankTitle() {
      if (this.title !== undefined) {
        return this.title.length === 0;
      }
    },

    tags() {
      let nizTagova = [];

      for (var i = 0; i < this.selectedTags.length; i++) {
        nizTagova.push(this.selectedTags[i].text);
      }
      return nizTagova;
    }
  },

  methods: {
    async createTask() {
      this.waitNet = true;
      var userarray = this.selectedUSers.map(e => e.id);
      var tagarray = this.selectedTags.map(e => e.tag_text);

      if (
        this.deadline !== "" ||
        this.deadline !== null ||
        this.deadline !== undefined
      ) {
        this.deadline = this.localToUTC(this.deadline);
      } else {
        this.deadline = undefined;
      }
      try {
        let res = await api.editTask(
          this.taskID,
          this.title,
          this.description,
          this.deadline,
          JSON.stringify(tagarray),
          JSON.stringify(userarray),
          this.selectedPriority
        );

        if (res.data.status === "OK") {
          store.commit("incDirtyCounter");
          store.commit("toastStatus", {
            ok: true,
            message: "Task '" + this.title + "' has been edited."
          });
        } else {
          store.commit("toastStatus", {
            ok: false,
            message: "Error: Couldn't edit task"
          });
        }
        store.dispatch("itemActionReset");
      } finally {
        this.waitNet = false;
      }
    },

    async loadInfo() {
      let idd = store.state.itemAction.edit;
      if (!idd) return;
      let sid = localStorage.sid;
      let res = await api.loadTaskInfo(store.state.itemAction.edit);

      if (!res) return;
      this.title = res.data.data[0].tsk_title;
      this.description = res.data.data[0].description;
      this.deadline = this.utcToLocal(res.data.data[0].tsk_deadline);
      this.selectedPriority = "" + res.data.data[0].pri_id;
      for (let i = 0; i < res.data.data[0].tags.length; i++) {
        let tag = {
          tag_text: res.data.data[0].tags[i].text
        };
        this.selectedTags.push(tag);
      }

      this.selectedUSers = res.data.data[0].usrworking;
      this.timecritical = res.data.data[0].time_critical;
      this.somethingChanged = false;
    }
  },

  mounted() {
    this.loadInfo();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Content/Task/TaskEdit.vue